// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Generic_Rep = require("../Data.Argonaut.Decode.Generic.Rep/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Generic_Rep = require("../Data.Argonaut.Encode.Generic.Rep/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var InputPin = (function () {
    function InputPin(value0) {
        this.value0 = value0;
    };
    InputPin.create = function (value0) {
        return new InputPin(value0);
    };
    return InputPin;
})();
var OutputPin = (function () {
    function OutputPin() {

    };
    OutputPin.value = new OutputPin();
    return OutputPin;
})();
var NodeLocation = (function () {
    function NodeLocation(value0) {
        this.value0 = value0;
    };
    NodeLocation.create = function (value0) {
        return new NodeLocation(value0);
    };
    return NodeLocation;
})();
var UnexistingNode = (function () {
    function UnexistingNode(value0) {
        this.value0 = value0;
    };
    UnexistingNode.create = function (value0) {
        return new UnexistingNode(value0);
    };
    return UnexistingNode;
})();
var NodeDefinition = (function () {
    function NodeDefinition(value0) {
        this.value0 = value0;
    };
    NodeDefinition.create = function (value0) {
        return new NodeDefinition(value0);
    };
    return NodeDefinition;
})();
var FunctionDeclaration = (function () {
    function FunctionDeclaration() {

    };
    FunctionDeclaration.value = new FunctionDeclaration();
    return FunctionDeclaration;
})();
var PinLocation = (function () {
    function PinLocation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    PinLocation.create = function (value0) {
        return function (value1) {
            return new PinLocation(value0, value1);
        };
    };
    return PinLocation;
})();
var FunctionUsage = (function () {
    function FunctionUsage(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    FunctionUsage.create = function (value0) {
        return function (value1) {
            return new FunctionUsage(value0, value1);
        };
    };
    return FunctionUsage;
})();
var AtApplication = (function () {
    function AtApplication(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AtApplication.create = function (value0) {
        return function (value1) {
            return new AtApplication(value0, value1);
        };
    };
    return AtApplication;
})();
var InsideNative = (function () {
    function InsideNative() {

    };
    InsideNative.value = new InsideNative();
    return InsideNative;
})();
var PlaceholderPosition = (function () {
    function PlaceholderPosition() {

    };
    PlaceholderPosition.value = new PlaceholderPosition();
    return PlaceholderPosition;
})();
var showScopedLocation = new Data_Show.Show(function (v) {
    if (v instanceof PlaceholderPosition) {
        return "(This position is a placeholder. If you see this then please open an issue on github)";
    };
    if (v instanceof InsideNative) {
        return "inside a native function";
    };
    if (v instanceof FunctionDeclaration) {
        return "at the declaration of a function";
    };
    if (v instanceof AtApplication) {
        return "at the " + (Lunarbox_Data_String.showIndex(v.value1) + (" input of node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0)));
    };
    if (v instanceof NodeDefinition) {
        return "at definition of node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0);
    };
    if (v instanceof FunctionUsage) {
        return "at function reference " + (Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value1) + (" in node " + Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value1)));
    };
    if (v instanceof NodeLocation) {
        return "at node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0);
    };
    if (v instanceof UnexistingNode) {
        return "at node " + (Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0) + " which doesn't exist");
    };
    if (v instanceof PinLocation && v.value1 instanceof OutputPin) {
        return "at the output of node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0);
    };
    if (v instanceof PinLocation && v.value1 instanceof InputPin) {
        return "at the " + (Lunarbox_Data_String.showIndex(v.value1.value0) + (" input of node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0)));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 63, column 1 - line 73, column 104): " + [ v.constructor.name ]);
});
var showPin = new Data_Show.Show(function (v) {
    if (v instanceof OutputPin) {
        return "output";
    };
    if (v instanceof InputPin) {
        return "input-" + Data_Show.show(Data_Show.showInt)(v.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 35, column 1 - line 37, column 49): " + [ v.constructor.name ]);
});
var mark = function (pin) {
    return function (id) {
        var pinLocation = new PinLocation(id, pin);
        var location = new NodeLocation(id);
        var $220 = Lunarbox_Data_Dataflow_Expression.Expression.create(location);
        var $221 = Lunarbox_Data_Dataflow_Expression.Expression.create(pinLocation);
        return function ($222) {
            return $220($221($222));
        };
    };
};
var outputNode = mark(new InputPin(0));
var inputNode = mark(OutputPin.value);
var genericScopedLocation = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof NodeLocation) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof UnexistingNode) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof NodeDefinition) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof FunctionDeclaration) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof PinLocation) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
    };
    if (x instanceof FunctionUsage) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))));
    };
    if (x instanceof AtApplication) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))))));
    };
    if (x instanceof InsideNative) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
    };
    if (x instanceof PlaceholderPosition) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))))));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 55, column 1 - line 55, column 66): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new NodeLocation(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new UnexistingNode(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new NodeDefinition(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return FunctionDeclaration.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new PinLocation(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new FunctionUsage(x.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return new AtApplication(x.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return InsideNative.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))) {
        return PlaceholderPosition.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 55, column 1 - line 55, column 66): " + [ x.constructor.name ]);
});
var genericPin = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof InputPin) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof OutputPin) {
        return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 27, column 1 - line 27, column 44): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new InputPin(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return OutputPin.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 27, column 1 - line 27, column 44): " + [ x.constructor.name ]);
});
var eqPin = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof InputPin && y instanceof InputPin) {
            return x.value0 === y.value0;
        };
        if (x instanceof OutputPin && y instanceof OutputPin) {
            return true;
        };
        return false;
    };
});
var eqScopedLocation = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof NodeLocation && y instanceof NodeLocation) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0);
        };
        if (x instanceof UnexistingNode && y instanceof UnexistingNode) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0);
        };
        if (x instanceof NodeDefinition && y instanceof NodeDefinition) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0);
        };
        if (x instanceof FunctionDeclaration && y instanceof FunctionDeclaration) {
            return true;
        };
        if (x instanceof PinLocation && y instanceof PinLocation) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0) && Data_Eq.eq(eqPin)(x.value1)(y.value1);
        };
        if (x instanceof FunctionUsage && y instanceof FunctionUsage) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0) && Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x.value1)(y.value1);
        };
        if (x instanceof AtApplication && y instanceof AtApplication) {
            return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(x.value0)(y.value0) && x.value1 === y.value1;
        };
        if (x instanceof InsideNative && y instanceof InsideNative) {
            return true;
        };
        if (x instanceof PlaceholderPosition && y instanceof PlaceholderPosition) {
            return true;
        };
        return false;
    };
});
var ordPin = new Data_Ord.Ord(function () {
    return eqPin;
}, function (x) {
    return function (y) {
        if (x instanceof InputPin && y instanceof InputPin) {
            return Data_Ord.compare(Data_Ord.ordInt)(x.value0)(y.value0);
        };
        if (x instanceof InputPin) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof InputPin) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof OutputPin && y instanceof OutputPin) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 25, column 1 - line 25, column 34): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var ordScopedLocation = new Data_Ord.Ord(function () {
    return eqScopedLocation;
}, function (x) {
    return function (y) {
        if (x instanceof NodeLocation && y instanceof NodeLocation) {
            return Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
        };
        if (x instanceof NodeLocation) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof NodeLocation) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof UnexistingNode && y instanceof UnexistingNode) {
            return Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
        };
        if (x instanceof UnexistingNode) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof UnexistingNode) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof NodeDefinition && y instanceof NodeDefinition) {
            return Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
        };
        if (x instanceof NodeDefinition) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof NodeDefinition) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof FunctionDeclaration && y instanceof FunctionDeclaration) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof FunctionDeclaration) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof FunctionDeclaration) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof PinLocation && y instanceof PinLocation) {
            var v = Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(ordPin)(x.value1)(y.value1);
        };
        if (x instanceof PinLocation) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof PinLocation) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof FunctionUsage && y instanceof FunctionUsage) {
            var v = Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(x.value1)(y.value1);
        };
        if (x instanceof FunctionUsage) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof FunctionUsage) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof AtApplication && y instanceof AtApplication) {
            var v = Data_Ord.compare(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Data_Ord.ordInt)(x.value1)(y.value1);
        };
        if (x instanceof AtApplication) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof AtApplication) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof InsideNative && y instanceof InsideNative) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof InsideNative) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof InsideNative) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof PlaceholderPosition && y instanceof PlaceholderPosition) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node.PinLocation (line 53, column 1 - line 53, column 56): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var encodeJsonPin = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericPin)(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "InputPin";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt)))(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "OutputPin";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))));
var encodeJsonScopedLocation = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericScopedLocation)(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "NodeLocation";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "UnexistingNode";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "NodeDefinition";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "FunctionDeclaration";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "PinLocation";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsProduct(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(encodeJsonPin))))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "FunctionUsage";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsProduct(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName))))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "AtApplication";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsProduct(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonInt))))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "InsideNative";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "PlaceholderPosition";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments)))))))))));
var decodeJsonPin = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericPin)(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "InputPin";
}))(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "OutputPin";
})))));
var decodeJsonScopedLocation = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericScopedLocation)(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "NodeLocation";
}))(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "UnexistingNode";
}))(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "NodeDefinition";
}))(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "FunctionDeclaration";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "PinLocation";
}))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsProduct(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(decodeJsonPin))))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "FunctionUsage";
}))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsProduct(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName))))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "AtApplication";
}))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsProduct(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Data_Argonaut_Decode_Class.decodeJsonInt))))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "InsideNative";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "PlaceholderPosition";
}))))))))))));
module.exports = {
    InputPin: InputPin,
    OutputPin: OutputPin,
    NodeLocation: NodeLocation,
    UnexistingNode: UnexistingNode,
    NodeDefinition: NodeDefinition,
    FunctionDeclaration: FunctionDeclaration,
    PinLocation: PinLocation,
    FunctionUsage: FunctionUsage,
    AtApplication: AtApplication,
    InsideNative: InsideNative,
    PlaceholderPosition: PlaceholderPosition,
    inputNode: inputNode,
    outputNode: outputNode,
    eqPin: eqPin,
    ordPin: ordPin,
    genericPin: genericPin,
    encodeJsonPin: encodeJsonPin,
    decodeJsonPin: decodeJsonPin,
    showPin: showPin,
    eqScopedLocation: eqScopedLocation,
    ordScopedLocation: ordScopedLocation,
    genericScopedLocation: genericScopedLocation,
    encodeJsonScopedLocation: encodeJsonScopedLocation,
    decodeJsonScopedLocation: decodeJsonScopedLocation,
    showScopedLocation: showScopedLocation
};
